export default __webpack_public_path__ + "static/media/24_7.566d9e98.svg";